export default {"src":"/_next/static/media/info-circle.6fa12a37.svg","height":192,"width":192};